import React, { useEffect, useState } from 'react';
import { ReactComponent as FileDownloadIcon } from "../../Assets/img/icons/Download-breadcrumb.svg";

const toBase64 = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result.split(',')[1]); // Get only the base64 part
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

function generateVCF(contactInfo, photoBase64) {
  let photoSection = '';
  if (photoBase64) {
    photoSection = `PHOTO;ENCODING=b;TYPE=JPEG:${photoBase64}`;
  }

  // Properly format the address
  const address = `;;${contactInfo.address.street};${contactInfo.address.city};${contactInfo.address.state};${contactInfo.address.postalCode};${contactInfo.address.country}`;

  const vcfContent = `BEGIN:VCARD
VERSION:3.0
FN:${contactInfo.name}
TEL;TYPE=CELL:${contactInfo.phone}
EMAIL:${contactInfo.email}
ADR:${address}
${photoSection}
END:VCARD`;

  return vcfContent;
}

function DownloadVCFButton({ contactInfo, photoBase64, layoutColor }) {
  const handleDownload = () => {
    const vcfContent = generateVCF(contactInfo, photoBase64);
    const blob = new Blob([vcfContent], { type: 'text/vcard' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${contactInfo.name}.vcf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  return (
    // <button onClick={handleDownload}>Download VCF</button>
    <div className='icon-border icons_share_qr me-3 flex-center' style={{ borderColor: layoutColor }}>
      <FileDownloadIcon className='icon-color' onClick={handleDownload} />
    </div>
  );
}

function Vcfcard({ userProfile, cardDetails, ContactStyles, layoutColor }) {
  const [photoBase64, setPhotoBase64] = useState('');

  useEffect(() => {
    if (cardDetails.profile_pic) {
      toBase64(cardDetails.profile_pic)
        .then(setPhotoBase64)
        .catch(console.error);
    }
  }, [cardDetails.profile_pic]);

  const contactInfo = {
    name: `${userProfile?.first_name || ''} ${userProfile?.last_name || ''}`,
    phone: ContactStyles?.mobile_number || '',
    email: ContactStyles?.email || '',
    address: {
      street: '304, Kedia Arcade, Infantry Road',
      city: 'Bengaluru',
      state: '',
      postalCode: '560001',
      country: 'India'
    },
  };

  return (
    <div className="App">
      <DownloadVCFButton contactInfo={contactInfo} photoBase64={photoBase64} layoutColor={layoutColor}/>
    </div>
  );
}

export default Vcfcard;
